import { FC } from 'react';
import './index.scss';
import { SvgIcon } from '@/components/icon';

interface Props {
  firstName: string;
  lastName: string;
  defaultPlaceholder?: boolean;
}

export const AvatarPlaceholder: FC<Props> = ({
  firstName,
  lastName,
  defaultPlaceholder = false,
}) => {
  let initials = '';
  if (!firstName && !lastName && !defaultPlaceholder)
    return (
      <div className={'avatar-placeholder'}>
        <span className={'initials'}>
          <SvgIcon
            style={{ height: '32px', width: '32px' }}
            type={'userCircle'}
          />
        </span>
      </div>
    );

  if (!firstName && !lastName && defaultPlaceholder) {
    initials = 'TC'; // ✅ Default placeholder
  } else if (firstName && !lastName) {
    initials = firstName.charAt(0).toUpperCase();
  } else if (!firstName && lastName) {
    initials = lastName.charAt(0).toUpperCase();
  } else {
    initials = `${firstName![0]}${lastName![0]}`.toUpperCase();
  }

  return (
    <div className={'avatar-placeholder'}>
      <span className={'initials'}>{initials}</span>
    </div>
  );
};
